import { P0, S, abs, earShape, fillAt, max, sq } from '../../geometry';

export const bunny = {
  name: 'Bunny',
  colors: ['#8E4EC6', '#D6409F'],
  draw(m, t) {
    let aL = -12 + 3 * S(t * 1.3),
      aR = 12 + 3 * S(t * 1.3 + 1),
      bL = 0,
      bR = 0,
      len = 30,
      pose = P0();
    if (m === 'happy') {
      aL = -14 - 10 * S(t * 8);
      aR = 14 + 10 * S(t * 8 + 0.4);
      pose.ty = -3 * abs(S(t * 6));
    }
    // Thinking: the ears take turns folding over and springing back.
    if (m === 'thinking') {
      bL = -85 * (0.5 + 0.5 * S(t * 2));
      bR = 85 * (0.5 + 0.5 * S(t * 2 + Math.PI));
    }
    if (m === 'talking') {
      aL = -12 - 7 * max(0, S(t * 10));
      aR = 12 + 7 * max(0, S(t * 10 + 0.5));
    }
    if (m === 'surprised') {
      aL = -4;
      aR = 4;
      len = 35;
    }
    if (m === 'paused') {
      aL = -72;
      aR = 72;
      bL = -15;
      bR = 15;
      len = 26;
      pose.ty = 2;
    }
    const L = earShape(41, 50, aL, bL, len, 6.2),
      Rr = earShape(59, 50, aR, bR, len, 6.2);
    return {
      strokes: [
        { c: 'a', pts: L.outline, n: 26 },
        { c: 'b', pts: L.inner },
        { c: 'a', pts: Rr.outline, n: 26 },
        { c: 'b', pts: Rr.inner },
        { c: 'a', pts: sq(50, 66, 22, 18, 2.5), n: 28 },
      ],
      eyes: { x: 50, y: 66 },
      pose,
    };
  },
  eyesOn: 'a',
  solid: (f) => fillAt(f, 0, 2, 4),
};
